import TablaCompras from "./../TCompras"
import Cabecera from "./../Cabecera"
import { useSelector } from "react-redux"
import { Alert } from "@material-ui/lab"
import VGrupoUsutilidad from "./../VGrupoUtilidad"
import { useState } from "react"
import { ButtonGroup, Button } from "@material-ui/core"
const VCompras = () => {
    const { referencia } = useSelector(store => store.cliente)
    const [tipoPago, setTipoPago] = useState(true)
    const onClick = () => {
        setTipoPago(!tipoPago)
    }
    if (referencia) return (
        <div style={{marginTop: "10px"}}>
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <ButtonGroup disableElevation variant="contained" color="primary">
                    <Button onClick={onClick} color={tipoPago ? 'secondary' : 'default'} >Individual</Button>
                    <Button onClick={onClick} color={!tipoPago ? 'secondary' : 'default'} >Grupal</Button>
                </ButtonGroup>
            </div>
            {
                (tipoPago) ? <div>
                    <TablaCompras />
                    <Cabecera />
                </div> : <VGrupoUsutilidad />
            }

        </div>
    )
    return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )
}
export default VCompras